// extracted by mini-css-extract-plugin
export default {"title-user":"MyCourseOnline_title-user__m1NgW"};